import React from "react"
import { DashboardTab } from "./DasbhoardTab";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Switch from "@mui/material/Switch";
import "./Dashboard.css";
import { Box } from "@mui/material";

function CustomTabPanel(props) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={sx}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  sx: PropTypes.object,
};

const Dashboard = () => {
  const [currentTabValue, setCurrentTabValue] = React.useState(0);
  const [currentToggle, setCurrentToggle] = React.useState(true);
  const handleTabChange = (event, newTabValue) => {
    setCurrentTabValue(newTabValue);
  };

  const tabList = ["User", "Ops Dashboard", "Case By Enterprise"];

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "90vh",
          overflow: "scroll",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          marginTop: "10%",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Tabs
            value={currentTabValue}
            onChange={handleTabChange}
            aria-label="basic tabs example"
          >
            {tabList.map((tab, index) => (
              <Tab label={tab} key={index} />
            ))}
          </Tabs>
          <div style={{ display: "inline" }}>
            Corporate
            <Switch defaultChecked checked={currentToggle} onChange={() => setCurrentToggle(!currentToggle)} />
            Insurance
          </div>
        </Box>
        {tabList.map((tab, index) => (
          <CustomTabPanel key={index} value={currentTabValue} index={index}>
            <DashboardTab
              currentToggle={currentToggle ? "Insurance" : "Corporate"}
              tabName={tab}
            />
          </CustomTabPanel>
        ))}
      </Box>
    </>
  );
};

export default Dashboard;
